import { Box } from '@mantine/core';
import type { QueryClient } from '@tanstack/react-query';
import type { MRT_TableInstance } from 'mantine-react-table';
import type { ReactNode } from 'react';
import type { Claim } from 'interfaces';
import { claimTableStyles } from 'styles/ClaimTableStyles';
import { ClaimsToolbarInternalActions } from './ClaimsToolbarInternalActions';

interface ClaimTableToolbarProps {
  table: MRT_TableInstance<Claim>;
  queryClient?: QueryClient;
  isProvider: boolean;
  children?: ReactNode;
}

export const ClaimTableToolbar = ({
  table,
  queryClient,
  isProvider,
  children,
}: ClaimTableToolbarProps): ReactNode => (
  <Box style={claimTableStyles.toolbar}>
    {children && <Box style={claimTableStyles.leadingActions}>{children}</Box>}
    <Box style={claimTableStyles.internalActions}>
      <ClaimsToolbarInternalActions
        table={table}
        queryClient={queryClient}
        isProvider={isProvider}
        placement="table"
      />
    </Box>
  </Box>
);
